/* global axios */
import ApiClient from './ApiClient';

class TeamSettingOverridesAPI extends ApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/teams/:team_id/setting_override
  // Returns 200 with payload or 204 (no content) when no override exists.
  show(teamId) {
    return axios.get(`${this.url}/${teamId}/setting_override`);
  }

  create(teamId, payload) {
    return axios.post(`${this.url}/${teamId}/setting_override`, payload);
  }

  update(teamId, payload) {
    return axios.patch(`${this.url}/${teamId}/setting_override`, payload);
  }

  delete(teamId) {
    return axios.delete(`${this.url}/${teamId}/setting_override`);
  }
}

export default new TeamSettingOverridesAPI();
